import { TemplatePage } from './types';

const weddingPage: TemplatePage = {
  header: {
    color: '#C6CAD6',
    icon: 'images/video-templates/wedding.jpg',
    title: 'Wedding Video Templates ',
    title_meta: 'Easy-to-Edit & Free Wedding Video Templates',
    description_meta:
      'Make your wedding business stand out in a crowded marketplace with Wave.video’s 20+ beautiful ' +
      'customizable wedding video templates.',
    description:
      'Make your wedding business stand out in a crowded marketplace with Wave.video’s beautiful customizable ' +
      'wedding video templates. Edit and download a wedding template of your choice in a matter of minutes!'
  },
  footer: {
    category: 'Wedding',
    description:
      'With Wave.video collection of stylish and easily customizable wedding video templates, you won’t need ' +
      'to spend hours creating and editing videos. You can personalize any template in a matter of minutes by ' +
      'changing colors, fonts, texts, music, visuals, and other elements of your video. All templates come in the ' +
      'most popular formats so that you can repurpose your video content for multiple social channels and platforms.'
  },
  content: [
    {
      type: 'templates',
      title: 'wedding',
      search: { name: 'wedding' }
    },
    {
      type: 'stocks',
      title: 'wedding',
      search: { name: 'wedding' }
    },
    { type: 'calendar' }
  ]
};

export default weddingPage;
